import { Icon } from "@chakra-ui/react";
const DarkDOWNArrow = () => {
  return (
    <>
      <Icon
        width="34"
        height="34"
        viewBox="0 0 34 34"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="17" cy="17" r="17" fill="black" />
        <circle cx="17" cy="17" r="10" fill="#B2B9BF" />
        <path d="M17 21L22.1962 15H11.8038L17 21Z" fill="black" />
      </Icon>
    </>
  );
};
export default DarkDOWNArrow;
